/* tslint:disable */
/* eslint-disable */
/**
 * The Thing API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RulesOptions
 */
export interface RulesOptions {
    /**
     * 
     * @type {boolean}
     * @memberof RulesOptions
     */
    addAnswerPromptAfterInterrogatories?: boolean | null;
}

export function RulesOptionsFromJSON(json: any): RulesOptions {
    return RulesOptionsFromJSONTyped(json, false);
}

export function RulesOptionsFromJSONTyped(json: any, ignoreDiscriminator: boolean): RulesOptions {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'addAnswerPromptAfterInterrogatories': !exists(json, 'addAnswerPromptAfterInterrogatories') ? undefined : json['addAnswerPromptAfterInterrogatories'],
    };
}

export function RulesOptionsToJSON(value?: RulesOptions | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'addAnswerPromptAfterInterrogatories': value.addAnswerPromptAfterInterrogatories,
    };
}


